import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";


import Landing from "./Pages/landing";
import './App.css';


function App() {
  document.title = "GlitterCelebrations";
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </Router>
		</div>
  );
}

export default App;
